// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3U8vd","messages":"Chat_messages__3Aw4v","dateDivider":"Chat_dateDivider__1leEe"};